
import { Dispatch } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { TableThingyActions } from "../actions/table_actions";
import {userdata} from "../typing/table_typing";
import { myfetchThunk } from "../../../app/myfetch";
import {masteruri} from "../../../config";


interface testdataResponsePayloadInterface{
    data:{
    user:userdata[],
    }
}

export const requestDataFromAPI =() => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{       
        console.log("DISPATCH");
        dispatch(myfetchThunk(
            true,
            masteruri+"/Users",
            {},
            "GET",
            (payload:testdataResponsePayloadInterface) => {
                console.log(payload);
                if (payload)
                {
                dispatch(
                     TableThingyActions.resetData(
                         {
                             data : payload.data.user,
                         }
                     )
                 );
                }
            },
            ()=>{}
        ) as any)
    }
}

export const deactivateUserFromAPI =(uuid:string) => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{       
        dispatch(myfetchThunk(
            true,
            masteruri+"/Users/"+uuid,
            {},
            "DELETE",
            () => {
                dispatch(requestDataFromAPI() as any);
            },
            ()=>{
                console.log("ERROR");
                dispatch(requestDataFromAPI() as any);
            }
        ) as any)
    }
}

export const deleteUserFromAPI =(uuid:string) => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{       
        dispatch(myfetchThunk(
            true,
            masteruri+"/Users/"+uuid,
            {},
            "DELETE",
            () => {
                dispatch(requestDataFromAPI() as any);
            },
            ()=>{
                console.log("ERROR");
                dispatch(requestDataFromAPI() as any);
            }
        ) as any)
    }
}